@if (!printing()) {
<header class="header">
  <div class="header__inner">
    @if (partner().code) {
    <a class="logo" href="{{ partner().url }}">
      <img class="logo__img" src="/assets/img/{{ partner().logoFile }}" width="{{ partner().logoWidth }}" height="{{ partner().logoHeight }}">
    </a>
    } @else {
    <a class="logo" routerLink="/">
      <img class="logo__img" src="/assets/img/logo.svg?v=2" width="300" height="77">
    </a>
    }
    @if (isAuthenticated()) {
    <app-main-nav></app-main-nav>
    <app-utility-nav></app-utility-nav>
    <app-user-nav></app-user-nav>
    } @else {
    <div class="vbc">
      <div class="vbc__text">Making Your Data Matter</div>
    </div>
    }
  </div>
</header>
}
